import { useState } from "react";
import { Link } from "react-router-dom";
import { hotKeywords } from "@/mocks/keywords";
import { categories } from "@/mocks/categories";
import Reveal from "@/components/base/Reveal";

const tabs = [{ slug: "all", name: "全部" }, ...categories.map((item) => ({ slug: item.slug, name: item.name }))];

export default function KeywordSection() {
  const [active, setActive] = useState("all");
  const filtered = hotKeywords
    .filter((keyword) => active === "all" || keyword.category === active)
    .sort((a, b) => b.heat - a.heat);

  return (
    <section className="border-y border-background-200/70 bg-background-100/60" aria-labelledby="home-keyword-title">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-medium tracking-[0.25em] text-primary-600">KEYWORDS</p>
            <h2 id="home-keyword-title" className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              热门黑料词索引
            </h2>
          </div>
          <p className="max-w-xl text-sm leading-relaxed text-foreground-600">
            热度按站内检索次数排序，点任意一个词直接跳到对应汇总。索引每日刷新一次。
          </p>
        </div>

        <div className="mt-6 flex flex-wrap gap-1 rounded-full border border-background-200 bg-background-50 p-1">
          {tabs.map((tab) => (
            <button
              key={tab.slug}
              type="button"
              onClick={() => setActive(tab.slug)}
              className={`rounded-full px-4 py-1.5 text-sm transition-colors ${
                active === tab.slug
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              {tab.name}
            </button>
          ))}
        </div>

        <div className="mt-6 flex flex-wrap gap-2.5">
          {filtered.map((keyword, index) => (
            <Reveal key={keyword.word} delay={Math.min(index * 25, 250)}>
              <Link
                to={`/entry/${keyword.entryId}`}
                className="group flex items-center gap-2 rounded-full border border-background-200 bg-background-50 px-4 py-2 transition-colors hover:border-primary-300"
                title={`${keyword.word} 相关汇总`}
              >
                <span className="text-sm text-foreground-900 transition-colors group-hover:text-primary-600">
                  {keyword.word}
                </span>
                <span className="flex items-center gap-0.5 text-xs tabular-nums text-accent-700">
                  <i className="ri-fire-line" />
                  {keyword.heat}
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}